import React from "react";

const BlackLine = (props) => {
  const position = props.position ? props.position : "";

  return <div className={`black-line ${position}`}></div>;
};

export default BlackLine;
